/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FloatingActionButton } from '@progress/kendo-react-buttons';
import { OrangeButton, WhiteButton } from '../../../components/buttonsComponent';
import { INTERNAL_BUTTON } from '../../../components/button';
import PopUpFiles from '../../../components/popUps/popUpFiles';
import CustomLabel from '../../../components/formField/components/label';
import FormFieldDate from '../../../components/formField/date';
import FormFieldDrop from '../../../components/formField/drop';
import LabelField from '../../../components/formField/label';
import GenericField, { INTERNAL_ICON } from '../../../components/formField/genericField';
import FormRow from '../../../components/formRow';
import ToggleInvoice from '../../../components/toggleInvoice';
import { useForms } from '../../../hooks';
import * as personService from '../../../services/person';
import * as relationshipService from '../../../services/relationship';
import * as walletService from '../../../services/wallet';
import LoadScreen from '../../load';
import {
  successNotification,
  errorNotification,
  warningNotification
} from '../../../components/notification';
import PopUpError from '../../../components/popUps/popUpError';
import PopupRelationshipType from '../../../components/popUps/popUpRelationshipType';
import PopupRelationshipStatus from '../../../components/popUps/popUpRelationshipStatus';
import PopupRelationshipSource from '../../../components/popUps/popUpRelationshipSource';
import PopUpConfirm from '../../../components/popUps/popUpConfirm';
import { DateNow } from '../../../utils/date';
import Person from '../../../components/person';
import Record from '../../../components/record';
import Schedule from '../../../components/schedule';
import Contracts from '../../contracts';
import PopUpRecord from '../../../components/popUps/popUpRecord';
import PopUpSchedule from '../../../components/popUps/popUpSchedule';
import { AuthContext } from '../../../auth/AuthContext';
import './styles.css';

const initialForm = {
  Data: DateNow(),
  Numero: '',
  Contato: null,
  Descricao: null
};

const initialRelationshipType = {
  Nome: '',
  Usuario: [],
  Editavel: false
};

const initialRelationshipStatus = {
  Nome: '',
  Editavel: false
};

const initialRelationshipSource = {
  Nome: '',
  Editavel: false
};

const RelationshipRegistration = ({ id: propId, onCancel, onSave }) => {
  const { id: paramId } = useParams();
  let id = propId !== undefined ? propId : paramId;
  const [priority, setPriority] = useState(null);
  const [priorities, setPriorities] = useState([]);
  const [relationshipType, setRelationshipType] = useState(initialRelationshipType);
  const [relationshipTypes, setRelationshipTypes] = useState([]);
  const [relationshipStatus, setRelationshipStatus] = useState(initialRelationshipStatus);
  const [relationshipStatuses, setRelationshipStatuses] = useState([]);
  const [relationshipSource, setRelationshipSource] = useState(initialRelationshipSource);
  const [relationshipSources, setRelationshipSources] = useState([]);
  const history = useHistory();
  const [form, updateProperty, setForm, updateFormValue] = useForms(initialForm);
  const [cpfCnpj, setCpfCpnj] = useState('');
  const [address, setAddress] = useState({});
  const [addresses, setAddresses] = useState([]);
  const [client, setClient] = useState(null);
  const [popUpError, setPopUpError] = useState(false);
  const [popUpErrorTitle, setPopUpErrorTitle] = useState('');
  const [popUpErrorMessage, setPopUpErrorMessage] = useState('');
  const [contact, setContact] = useState(null);
  const [contacts, setContacts] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingType, setLoadingType] = useState(false);
  const [loadingRelationshipTypes, setLoadingRelationshipTypes] = useState(false);
  const [loadingClient, setLoadingClient] = useState(false);
  const [loadingRecord, setLoadingRecord] = useState(false);
  const [records, setRecords] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [loadingSchedule, setLoadingSchedule] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const { walletSelected, userJwt, walletJwt } = useContext(AuthContext);
  const [expanded, setExpanded] = useState(false);
  const [responsible, setResponsible] = useState(null);
  const [responsibles, setResponsibles] = useState([]);
  const [email, setEmail] = useState(null);
  const [popUpFile, setPopUpFile] = useState(false);
  const [files, setFiles] = useState([]);

  const hasPermission = (value) => {
    let permissions = [];
    if (walletSelected?.ListaPermissoes) permissions = walletSelected.ListaPermissoes;
    if (permissions.includes('1')) return true;
    return permissions.includes(value);
  };

  const [popUpsVisibilities, setPopUpsVisibilities] = useState({
    addRelationshipType: false,
    editRelationshipType: false,
    addRelationshipStatus: false,
    editRelationshipStatus: false,
    addRelationshipSource: false,
    editRelationshipSource: false,
    addInteration: false,
    deleteInteration: false,
    addSchedule: false,
    deleteSchedule: false
  });

  const setPopUpVisibility = (propName, value) => {
    setPopUpsVisibilities({
      ...popUpsVisibilities,
      [propName]: value
    });
  };
  const updateClientDetails = async (client, address, contact) => {
    if (contact) setEmail(contact.Email);
  };

  const setClientAddress = async (client, idAddress, contact) => {
    if (client.TipoPessoa === 0) {
      setCpfCpnj(client.CPF);
      setAddress(client.Endereco);
      setContact({ Nome: contact });
      setContacts(null);
      setEmail(client.Email);
    } else {
      let addresses = [];
      if (client.EnderecoPrincipal != null) addresses.push(client.EnderecoPrincipal);
      addresses = addresses.concat(client.OutrosEnderecos);
      addresses = addresses.map((item) => ({
        ...item,
        EnderecoCompleto: [item.Logradouro, item.Numero, item.Complemento, item.Bairro]
          .filter(Boolean)
          .join(', ')
      }));
      let newAddress = addresses.filter((x) => x.Id === idAddress);
      newAddress = newAddress.length > 0 ? newAddress[0] : null;
      if (newAddress != null) {
        setCpfCpnj(newAddress.CNPJ ? newAddress.CNPJ : '');
        setAddress(newAddress);
      } else if (addresses.length === 1) {
        setCpfCpnj(addresses[0].CNPJ ? addresses[0].CNPJ : '');
        setAddress(addresses[0]);
      }
      setAddresses(addresses);
      const contacts = [];
      if (client.Contatos?.length > 0) {
        client.Contatos.forEach((item) => {
          contacts.push(item);
        });
      }
      if (addresses?.length > 0) {
        addresses.forEach((item1) => {
          if (item1.Contatos?.length > 0) {
            item1.Contatos.forEach((item2) => {
              contacts.push(item2);
            });
          }
        });
      }
      contacts.sort();
      if (!contacts) {
        setContact({ Nome: contact });
        setContacts(null);
      } else if (contacts.length > 0) {
        const contato = contacts.find((x) => x.Id === contact);
        setContact(contato);
        if (contato) setEmail(contato.Email);
        contacts.sort((a, b) => {
          if (a.Nome < b.Nome) {
            return -1;
          }
          if (a.Nome > b.Nome) {
            return 1;
          }
          return 0;
        });
        setContacts(contacts);
      }
    }
  };

  const loadPriorities = async () => {
    setLoadingRelationshipTypes(true);
    const { data } = await relationshipService.getPriorities();
    setPriorities(data);
    if (data.length > 0) setPriority(data[0]);
    setLoadingRelationshipTypes(false);
    return data;
  };

  const loadRelationshipTypes = async (relationshipType) => {
    setLoadingRelationshipTypes(true);
    const { data } = await relationshipService.getRelationshipTypes();
    setRelationshipTypes(data);
    setRelationshipType(relationshipType);
    setLoadingRelationshipTypes(false);
    return data;
  };

  const loadRelationshipStatuses = async (relationshipStatus) => {
    setLoadingRelationshipTypes(true);
    const { data } = await relationshipService.getRelationshipStatuses();
    setRelationshipStatuses(data);
    setRelationshipStatus(relationshipStatus);
    setLoadingRelationshipTypes(false);
    return data;
  };

  const loadRelationshipSources = async (relationshipSource) => {
    setLoadingRelationshipTypes(true);
    const { data } = await relationshipService.getRelationshipSources();
    setRelationshipSources(data);
    setRelationshipSource(relationshipSource);
    setLoadingRelationshipTypes(false);
    return data;
  };

  const loadInterations = async (id) => {
    const response = await relationshipService.getById(id);
    const relationship = response.data;
    if (relationship.RelacionamentoInteracao.length > 0) {
      const records = relationship.RelacionamentoInteracao.map((item) => {
        const dataCriacaoLocal = new Date(`${item.DataCriacao}Z`);
        const dataModificacaoLocal = new Date(`${item.DataModificacao}Z`);
        return {
          ...item,
          DataCriacao: dataCriacaoLocal,
          DataModificacao: dataModificacaoLocal
        };
      });
      setRecords(records);
    } else {
      setRecords([]);
    }
  };

  const loadSchedules = async (id) => {
    const response = await relationshipService.getById(id);
    const relationship = response.data;
    if (relationship.RelacionamentoAgenda.length > 0) {
      const schedules = relationship.RelacionamentoAgenda.map((item) => {
        const dataLocal = new Date(`${item.Data}Z`);
        const dataCriacaoLocal = new Date(`${item.DataCriacao}Z`);
        const dataModificacaoLocal = new Date(`${item.DataModificacao}Z`);
        return {
          ...item,
          DataCriacao: dataCriacaoLocal,
          DataModificacao: dataModificacaoLocal,
          Data: dataLocal
        };
      });
      setSchedules(schedules);
    } else {
      setSchedules([]);
    }
  };

  const loadResponsibles = async () => {
    setLoadingRelationshipTypes(true);
    const { data } = await walletService.getUsers();
    setResponsibles(data);
    setLoadingRelationshipTypes(false);
    return data;
  };

  useEffect(async () => {
    setLoadingRelationshipTypes(true);
    setLoadingClient(true);
    if (id && id !== '0') {
      let response = await relationshipService.getById(id);
      const relationship = response.data;
      // ############## Load Relationship Types ##############
      setForm({
        Data: new Date(relationship.Data),
        Numero: relationship.Numero,
        Titulo: relationship.Titulo,
        Descricao: relationship.Descricao,
        UsuarioNome: relationship.UsuarioNome
      });
      if (relationship.RelacionamentoInteracao.length > 0) {
        const records = relationship.RelacionamentoInteracao.map((item) => {
          const dataCriacaoLocal = new Date(`${item.DataCriacao}Z`);
          const dataModificacaoLocal = new Date(`${item.DataModificacao}Z`);
          return {
            ...item,
            DataCriacao: dataCriacaoLocal,
            DataModificacao: dataModificacaoLocal
          };
        });
        setRecords(records);
      }
      if (relationship.RelacionamentoAgenda.length > 0) {
        const schedules = relationship.RelacionamentoAgenda.map((item) => {
          const dataLocal = new Date(`${item.Data}Z`);
          const dataCriacaoLocal = new Date(`${item.DataCriacao}Z`);
          const dataModificacaoLocal = new Date(`${item.DataModificacao}Z`);
          return {
            ...item,
            DataCriacao: dataCriacaoLocal,
            DataModificacao: dataModificacaoLocal,
            Data: dataLocal
          };
        });
        setSchedules(schedules);
      }
      const priorities = await loadPriorities();
      const itemPriority = priorities.find((element) => element.Id === relationship.PrioridadeId);
      setPriority(itemPriority);

      const relationshipTypes = await loadRelationshipTypes();
      let itemRelationshipType = relationshipTypes.find(
        (element) => element.Id === relationship.TipoRelacionamentoId
      );
      itemRelationshipType = {
        ...itemRelationshipType,
        Editavel: true
      };
      setRelationshipType(itemRelationshipType);

      const relationshipStatuses = await loadRelationshipStatuses();
      let itemRelationshipStatus = relationshipStatuses.find(
        (element) => element.Id === relationship.SituacaoRelacionamentoId
      );
      itemRelationshipStatus = {
        ...itemRelationshipStatus,
        Editavel: true
      };
      setRelationshipStatus(itemRelationshipStatus);

      const relationshipSources = await loadRelationshipSources();
      let itemRelationshipSource = relationshipSources.find(
        (element) => element.Id === relationship.OrigemRelacionamentoId
      );
      itemRelationshipSource = {
        ...itemRelationshipSource,
        Editavel: true
      };
      setRelationshipSource(itemRelationshipSource);

      const responsibles = await loadResponsibles();
      const responsbile = responsibles.find((element) => element.Id === relationship.ResponsavelId);
      setResponsible(responsbile);

      setLoadingRelationshipTypes(false);

      // ############## Load Client ##############
      response = await personService.getById(relationship.PessoaId);
      const client = response.data;
      setClient(client);
      setEmail(client.Email);
      await setClientAddress(client, relationship.EnderecoId, relationship.Contato);
      setLoadingClient(false);
    } else {
      // ############## Load Relationship Types ##############
      const priorities = await loadPriorities();
      const relationshipTypes = await loadRelationshipTypes();
      const relationshipStatuses = await loadRelationshipStatuses();
      const relationshipSources = await loadRelationshipSources();
      const responsibles = await loadResponsibles();
      setLoadingRelationshipTypes(false);

      // ############## Load Client ##############
      setContact(null);
      setEmail(null);
      setLoadingClient(false);
    }
  }, [id]);

  const redirectToRelationships = (id) => {
    if (onSave) {
      onSave();
    } else {
      if (id) history.push(`/relationships/${id}`);
      else history.push(`/relationships`);
    }
  };

  const validate = async () => {
    if (loading || loadingType || loadingClient || loadingRelationshipTypes || loadingRecord) {
      warningNotification('Aguarde o carregamento dos dados.');
      return false;
    }
    return true;
  };

  const createAttachs = async (id) => {
    const attachRequests = files.map((file) => relationshipService.createFile(id, file.getRawFile()));
    const attachResponses = await Promise.all(attachRequests);

    const isAllRequestsRight = attachResponses.reduce(
      (acc, currentResponse) => acc && currentResponse.status === 200,
      true
    );

    if (!isAllRequestsRight) {
      const erro = ['Houve um erro ao tentar anexar um ou mais arquivos:'];
      attachResponses.forEach((element) => {
        const { data } = element;
        if (data.MensagemUsuario !== undefined) erro.push(data.MensagemUsuario);
        else erro.push(data);
      });
      return erro;
    }
    return null;
  };

  const submitFormValidated = async (button) => {
    setLoading(true);

    const bodyForm = {
      ...form,
      PessoaId: client.Id,
      PrioridadeId: priority.Id,
      TipoRelacionamentoId: relationshipType?.Id,
      SituacaoRelacionamentoId: relationshipStatus?.Id,
      OrigemRelacionamentoId: relationshipSource?.Id,
      EnderecoId: address?.Id,
      Titulo: form.Titulo,
      Descricao: form.Descricao,
      Contato: contact?.Id ? contact?.Id : contact?.Nome,
      ResponsavelId: responsible?.Email
    };
    let response = null;
    if (id && id !== '0') {
      response = await relationshipService.update(id, bodyForm);
      if (response.status === 200) {
        const erro = await createAttachs(id);
        if (erro) errorNotification(erro);
        if (button === 'salvarSair') {
          redirectToRelationships(id);
        } else if (button === 'salvar') {
          await loadInterations(id);
          await loadSchedules(id);
        }
        if (!erro) successNotification('Registro atualizado com sucesso!');
      } else {
        const { data } = response;
        if (data.MensagemUsuario !== undefined) errorNotification(data.MensagemUsuario);
        else errorNotification(data);
      }
    } else {
      response = await relationshipService.create(bodyForm);
      const { data } = response;
      id = data;
      if (response.status === 200) {
        const erro = await createAttachs(id);
        if (erro) errorNotification(erro);
        if (button === 'salvarSair') {
          redirectToRelationships(id);
        } else if (button === 'salvar') {
          history.push(`/relationships/relationshipRegistration/${id}`);
        }
        if (!erro) successNotification('Registro criado com sucesso!');
      } else {
        const { data } = response;
        if (data.MensagemUsuario !== undefined) errorNotification(data.MensagemUsuario);
        else errorNotification(data);
      }
    }

    setLoading(false);
    return id;
  };

  const submitForm = async (e) => {
    e.preventDefault();
    const button = e.nativeEvent?.submitter?.name;
    if (await validate()) {
      submitFormValidated(button);
    }
  };

  const onItemDeleteRecord = async (record) => {
    setPopUpVisibility('deleteInteration', true);
    setSelectedRecord(record);
  };

  const onItemEditRecord = (record) => {
    setPopUpVisibility('addInteration', true);
    setSelectedRecord(record);
  };

  const deleteInteration = async () => {
    setLoadingRecord(true);
    const response = await relationshipService.excludeRelationshipInteration(selectedRecord.Id);
    if (response.status === 200) {
      await loadInterations(id);
      await loadSchedules(id);
      successNotification('Interação excluída com sucesso!');
    } else {
      const { data } = response;
      if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
      else errorNotification('Houve um erro ao tentar excluir uma interação.');
    }
    setLoadingRecord(false);
  };

  const handleContractToggle = (event) => {
    setExpanded(true);
  };

  const addInteration = async (record) => {
    setLoadingRecord(true);
    let newId = id;
    if (!newId || newId === '0')
      if (await validate()) {
        newId = await submitFormValidated('interation');
      }

    const bodyForm = {
      Descricao: record.Descricao,
      RelacionamentoId: newId
    };
    let response = null;
    if (selectedRecord) {
      response = await relationshipService.updateRelationshipInteration(
        bodyForm,
        selectedRecord.Id
      );
      if (response.status === 200) {
        setSelectedRecord(null);
        await loadInterations(newId);
        successNotification('Interação atualizada com sucesso!');
      } else {
        const { data } = response;
        if (data.MensagemUsuario !== undefined) errorNotification(data.MensagemUsuario);
        else errorNotification(data);
      }
    } else {
      response = await relationshipService.createRelationshipInteration(bodyForm);
      if (response.status === 200) {
        history.push(`/relationships/relationshipRegistration/${newId}`);
        await loadInterations(newId);
        successNotification('Interação criada com sucesso!');
      } else {
        const { data } = response;
        if (data.MensagemUsuario !== undefined) errorNotification(data.MensagemUsuario);
        else errorNotification(data);
      }
    }
    setLoadingRecord(false);
  };

  const onItemDeleteSchedule = async (schedule) => {
    setPopUpVisibility('deleteSchedule', true);
    setSelectedSchedule(schedule);
  };

  const onItemEditSchedule = (schedule) => {
    setPopUpVisibility('addSchedule', true);
    setSelectedSchedule(schedule);
  };

  const deleteSchedule = async () => {
    setLoadingSchedule(true);
    const response = await relationshipService.excludeRelationshipSchedule(selectedSchedule.Id);
    if (response.status === 200) {
      await loadSchedules(id);
      successNotification('Interação excluída com sucesso!');
    } else {
      const { data } = response;
      if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
      else errorNotification('Houve um erro ao tentar excluir uma interação.');
    }
    setLoadingSchedule(false);
  };

  const addSchedule = async (schedule) => {
    setLoadingSchedule(true);
    let newId = id;
    if (!newId || newId === '0')
      if (await validate()) {
        newId = await submitFormValidated('schedule');
      }

    const bodyForm = {
      ...schedule,
      RelacionamentoId: newId
    };
    let response = null;
    if (selectedSchedule) {
      response = await relationshipService.updateRelationshipSchedule(
        bodyForm,
        selectedSchedule.Id
      );
      if (response.status === 200) {
        setSelectedSchedule(null);
        await loadSchedules(newId);
        successNotification('Agenda atualizada com sucesso!');
      } else {
        const { data } = response;
        if (data.MensagemUsuario !== undefined) errorNotification(data.MensagemUsuario);
        else errorNotification(data);
      }
    } else {
      response = await relationshipService.createRelationshipSchedule(bodyForm);
      if (response.status === 200) {
        history.push(`/relationships/relationshipRegistration/${newId}`);
        await loadSchedules(newId);
        successNotification('Agenda criada com sucesso!');
      } else {
        const { data } = response;
        if (data.MensagemUsuario !== undefined) errorNotification(data.MensagemUsuario);
        else errorNotification(data);
      }
    }
    setLoadingSchedule(false);
  };

  return loading ? (
    <LoadScreen />
  ) : (
    <>
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"
      />
      {id && id !== '0' ? <h1>Atualizar Registro</h1> : <h1>Novo Registro</h1>}
      <div className="buttons-relationship-registration">
        <div className="config-components-popup-button">
          <FloatingActionButton
            icon={INTERNAL_BUTTON.BUTTON_ATTACH}
            onClick={() => {
              setPopUpFile(true);
            }}
          />
        </div>
      </div>
      <form className="form-general-relationship" onSubmit={submitForm}>
        {loadingType ? (
          <LoadScreen />
        ) : (
          <>
            <ToggleInvoice title="Registro de Atividade" startExpanded>
              {loadingRelationshipTypes ? (
                <LoadScreen />
              ) : (
                <>
                  <FormRow withShrink>
                    <FormFieldDrop
                      titleLabel="Tipo de Registro"
                      defaultValueSelect="Selecione..."
                      onChangeValue={(val) => {
                        const relationshipType = val.value;
                        if (relationshipType == null) setRelationshipType(initialForm);
                        else {
                          relationshipType.Editavel = true;
                          setRelationshipType(relationshipType);
                        }
                      }}
                      value={relationshipType}
                      className={id && id !== '0' ? 'fill-50-field-margin' : 'fill-50-field'}
                      infosSelect={relationshipTypes}
                      dataItemKey="Id"
                      textField="Nome"
                      enablePencil={hasPermission(1) && relationshipType?.Editavel}
                      enableIcon={hasPermission(1)}
                      onClickIcon={() => setPopUpVisibility('addRelationshipType', true)}
                      onClickPencil={() => setPopUpVisibility('editRelationshipType', true)}
                      required
                    />
                    <FormFieldDate
                      titleLabel="Data"
                      value={form.Data}
                      valueOnChange={(val) => updateFormValue('Data', val)}
                      className={id && id !== '0' ? 'fill-25-field' : 'fill-50-field'}
                      required
                      disabled
                    />
                    {id && id !== '0' && (
                      <GenericField
                        titleLabel="Número"
                        enableInfo
                        onChangeValue={updateProperty}
                        msg="Número sequencial do registro"
                        valueInput={form.Numero}
                        classNameWrapper="fill-25-field"
                        required
                        name="Numero"
                        typeNumber
                        disabled
                      />
                    )}
                  </FormRow>
                  <FormRow withShrink>
                    <FormFieldDrop
                      titleLabel="Origem"
                      defaultValueSelect="Selecione..."
                      onChangeValue={(val) => {
                        const relationshipSource = val.value;
                        if (relationshipSource == null) setRelationshipSource(initialForm);
                        else {
                          relationshipSource.Editavel = true;
                          setRelationshipSource(relationshipSource);
                        }
                      }}
                      value={relationshipSource}
                      className="fill-25-field"
                      infosSelect={relationshipSources}
                      dataItemKey="Id"
                      textField="Nome"
                      enablePencil={hasPermission(1) && relationshipSource?.Editavel}
                      enableIcon={hasPermission(1)}
                      onClickIcon={() => setPopUpVisibility('addRelationshipSource', true)}
                      onClickPencil={() => setPopUpVisibility('editRelationshipSource', true)}
                      required
                    />
                    <FormFieldDrop
                      titleLabel="Situação"
                      defaultValueSelect="Selecione..."
                      onChangeValue={(val) => {
                        const relationshipStatus = val.value;
                        if (relationshipStatus == null) setRelationshipStatus(initialForm);
                        else {
                          relationshipStatus.Editavel = true;
                          setRelationshipStatus(relationshipStatus);
                        }
                      }}
                      value={relationshipStatus}
                      className="fill-25-field"
                      infosSelect={relationshipStatuses}
                      dataItemKey="Id"
                      textField="Nome"
                      enablePencil={hasPermission(1) && relationshipStatus?.Editavel}
                      enableIcon={hasPermission(1)}
                      onClickIcon={() => setPopUpVisibility('addRelationshipStatus', true)}
                      onClickPencil={() => setPopUpVisibility('editRelationshipStatus', true)}
                      required
                    />
                    <FormFieldDrop
                      titleLabel="Prioridade"
                      defaultValueSelect="Selecione..."
                      onChangeValue={(val) => {
                        setPriority(val.value);
                      }}
                      value={priority}
                      className="fill-25-field"
                      infosSelect={priorities}
                      dataItemKey="Id"
                      textField="Nome"
                      required
                    />
                    <FormFieldDrop
                      titleLabel="Responsável"
                      defaultValueSelect="Selecione..."
                      onChangeValue={(val) => {
                        setResponsible(val.value);
                      }}
                      value={responsible}
                      className="fill-25-field"
                      infosSelect={responsibles}
                      dataItemKey="Id"
                      textField="Nome"
                      required
                    />
                  </FormRow>
                  {id && id !== '0' && (
                    <FormRow>
                      <LabelField
                        titleLabel="Criado Por"
                        classNameWrapper="fill-25-field"
                        valueLabel={form.UsuarioNome}
                      />
                    </FormRow>
                  )}
                </>
              )}
            </ToggleInvoice>
          </>
        )}
        <ToggleInvoice title="Dados da Pessoa Física ou Pessoa Jurídica" startExpanded>
          {loadingClient ? (
            <LoadScreen />
          ) : (
            <>
              <Person
                person={client}
                setPerson={setClient}
                cpfCnpj={cpfCnpj}
                setCpfCpnj={setCpfCpnj}
                address={address}
                setAddress={setAddress}
                addresses={addresses}
                setAddresses={setAddresses}
                contact={contact}
                setContact={setContact}
                contacts={contacts}
                setContacts={setContacts}
                afterClientSelection={updateClientDetails}
                searchType="T"
              />
              {address?.RetemISS && (
                <FormRow>
                  <h3 style={{ color: 'red', fontWeight: 'bold' }}>Cliente retém ISS</h3>
                </FormRow>
              )}
            </>
          )}
        </ToggleInvoice>
        <ToggleInvoice title="Histórico de Relacionamento" onSelect={handleContractToggle}>
          <FormRow>
            <CustomLabel>Contratos</CustomLabel>
          </FormRow>
          {expanded && (
            <Contracts
              head={false}
              byClient={true}
              clientId={client?.Id}
              addressId={address?.Id}
              haveCheckbox={false}
              maxHeight={300}
              havePreview={hasPermission('29')}
              haveOnClick={false}
              seekControl={false}
              haveValue={false}
            />
          )}
          <FormRow space10>
            <OrangeButton
              onClick={() => {
                if (userJwt && walletJwt) {
                  const clientId = client?.Id;
                  const addressId = address?.Id;
                  let redirect = '/invoices?byClient=true';
                  if (clientId) redirect = `${redirect}&clientId=${client?.Id}`;
                  if (addressId) redirect = `${redirect}&addressId=${address?.Id}`;
                  redirect = encodeURIComponent(redirect);
                  const url = `${window.location.origin}/login?t-usuario=${userJwt}&t-carteira=${walletJwt}&redirect=${redirect}`;
                  window.open(url, '_blank');
                } else {
                  errorNotification('Usuário não autenticado!');
                }
              }}
              disable={!hasPermission('30')}
            >
              Faturamento
            </OrangeButton>
            <OrangeButton
              onClick={() => {
                if (userJwt && walletJwt) {
                  const clientId = client?.Id;
                  const addressId = address?.Id;
                  let redirect = '/expenses?byClient=true';
                  if (clientId) redirect = `${redirect}&clientId=${client?.Id}`;
                  if (addressId) redirect = `${redirect}&addressId=${address?.Id}`;
                  redirect = encodeURIComponent(redirect);
                  const url = `${window.location.origin}/login?t-usuario=${userJwt}&t-carteira=${walletJwt}&redirect=${redirect}`;
                  window.open(url, '_blank');
                } else {
                  errorNotification('Usuário não autenticado!');
                }
              }}
              disable={!hasPermission('31')}
            >
              Compras
            </OrangeButton>
            <OrangeButton
              onClick={() => {
                if (userJwt && walletJwt) {
                  const clientId = client?.Id;
                  const addressId = address?.Id;
                  let redirect = '/attendances?byClient=true';
                  if (clientId) redirect = `${redirect}&clientId=${client?.Id}`;
                  if (addressId) redirect = `${redirect}&addressId=${address?.Id}`;
                  redirect = encodeURIComponent(redirect);
                  const url = `${window.location.origin}/login?t-usuario=${userJwt}&t-carteira=${walletJwt}&redirect=${redirect}`;
                  window.open(url, '_blank');
                } else {
                  errorNotification('Usuário não autenticado!');
                }
              }}
              disable={!hasPermission('28')}
            >
              Propostas
            </OrangeButton>
            <OrangeButton
              onClick={() => {
                if (userJwt && walletJwt) {
                  const clientId = client?.Id;
                  const addressId = address?.Id;
                  let redirect = '/relationships?byClient=true';
                  if (clientId) redirect = `${redirect}&clientId=${client?.Id}`;
                  if (addressId) redirect = `${redirect}&addressId=${address?.Id}`;
                  redirect = encodeURIComponent(redirect);
                  const url = `${window.location.origin}/login?t-usuario=${userJwt}&t-carteira=${walletJwt}&redirect=${redirect}`;
                  window.open(url, '_blank');
                } else {
                  errorNotification('Usuário não autenticado!');
                }
              }}
              disable={!hasPermission('45')}
            >
              Registros
            </OrangeButton>
          </FormRow>
        </ToggleInvoice>
        <ToggleInvoice title="Registro" startExpanded>
          <FormRow>
            <GenericField
              titleLabel="Título"
              classNameWrapper="fill-100-field"
              isTextArea
              rows={3}
              valueInput={form.Titulo}
              onChangeValue={(val) => {
                updateFormValue('Titulo', val.value);
              }}
              required
            />
          </FormRow>
          <FormRow>
            <GenericField
              titleLabel="Descrição"
              classNameWrapper="fill-100-field"
              isTextArea
              rows={6}
              valueInput={form.Descricao}
              onChangeValue={(val) => {
                updateFormValue('Descricao', val.value);
              }}
              required
            />
          </FormRow>
        </ToggleInvoice>
        <ToggleInvoice title="Agendamentos" startExpanded>
          {loadingSchedule ? (
            <LoadScreen />
          ) : (
            <FormRow>
              <Schedule
                schedules={schedules}
                setSchedules={setSchedules}
                editColumn={true}
                onItemEdit={onItemEditSchedule}
                deleteColumn={true}
                onItemDelete={onItemDeleteSchedule}
                email={email}
              />
            </FormRow>
          )}
          <FormRow justifyEnd space10>
            <OrangeButton
              onClick={() => {
                setSelectedSchedule(null);
                setPopUpVisibility('addSchedule', true);
              }}
            >
              Adicionar Agenda
            </OrangeButton>
          </FormRow>
        </ToggleInvoice>
        <ToggleInvoice title="Interações" startExpanded>
          {loadingRecord ? (
            <LoadScreen />
          ) : (
            <FormRow>
              <Record
                records={records}
                setRecords={setRecords}
                editColumn={true}
                onItemEdit={onItemEditRecord}
                deleteColumn={true}
                onItemDelete={onItemDeleteRecord}
              />
            </FormRow>
          )}
          <FormRow justifyEnd space10>
            <OrangeButton
              onClick={() => {
                setSelectedRecord(null);
                setPopUpVisibility('addInteration', true);
              }}
            >
              Adicionar Interação
            </OrangeButton>
          </FormRow>
        </ToggleInvoice>
        <FormRow justifyEnd space15 marginTop40>
          <OrangeButton type="submit" name="salvar">
            Salvar
          </OrangeButton>
          <OrangeButton type="submit" name="salvarSair">
            Salvar e Sair
          </OrangeButton>
          <WhiteButton type="button" onClick={() => onCancel ? onCancel() : redirectToRelationships(id)}>Cancelar</WhiteButton>
        </FormRow>
      </form>
      <PopupRelationshipType
        visible={popUpsVisibilities.addRelationshipType}
        setVisible={(val) => setPopUpVisibility('addRelationshipType', val)}
        reloadRelationshipTypes={loadRelationshipTypes}
      />
      <PopupRelationshipType
        visible={popUpsVisibilities.editRelationshipType}
        setVisible={(val) => setPopUpVisibility('editRelationshipType', val)}
        reloadRelationshipTypes={loadRelationshipTypes}
        entity={relationshipType}
        isEdit
      />
      <PopupRelationshipStatus
        visible={popUpsVisibilities.addRelationshipStatus}
        setVisible={(val) => setPopUpVisibility('addRelationshipStatus', val)}
        reloadRelationshipStatuses={loadRelationshipStatuses}
      />
      <PopupRelationshipStatus
        visible={popUpsVisibilities.editRelationshipStatus}
        setVisible={(val) => setPopUpVisibility('editRelationshipStatus', val)}
        reloadRelationshipStatuses={loadRelationshipStatuses}
        entity={relationshipStatus}
        isEdit
      />
      <PopupRelationshipSource
        visible={popUpsVisibilities.addRelationshipSource}
        setVisible={(val) => setPopUpVisibility('addRelationshipSource', val)}
        reloadRelationshipSources={loadRelationshipSources}
      />
      <PopupRelationshipSource
        visible={popUpsVisibilities.editRelationshipSource}
        setVisible={(val) => setPopUpVisibility('editRelationshipSource', val)}
        reloadRelationshipSources={loadRelationshipSources}
        entity={relationshipSource}
        isEdit
      />
      <PopUpError
        visible={popUpError}
        setVisible={setPopUpError}
        title={popUpErrorTitle}
        message={popUpErrorMessage}
      />
      <PopUpRecord
        visible={popUpsVisibilities.addInteration}
        setVisible={(val) => setPopUpVisibility('addInteration', val)}
        addRecord={addInteration}
        selectedRecord={selectedRecord}
      />
      <PopUpSchedule
        visible={popUpsVisibilities.addSchedule}
        setVisible={(val) => setPopUpVisibility('addSchedule', val)}
        addSchedule={addSchedule}
        selectedSchedule={selectedSchedule}
      />
      <PopUpConfirm
        onConfirm={deleteInteration}
        visible={popUpsVisibilities.deleteInteration}
        setVisible={(val) => setPopUpVisibility('deleteInteration', val)}
        title="Confirmação"
        message="Você tem certeza que deseja excluir a interação selecionada?"
      />
      <PopUpConfirm
        onConfirm={deleteSchedule}
        visible={popUpsVisibilities.deleteSchedule}
        setVisible={(val) => setPopUpVisibility('deleteSchedule', val)}
        title="Confirmação"
        message="Você tem certeza que deseja excluir a agenda selecionada?"
      />
      <PopUpFiles
        visible={popUpFile}
        setVisible={setPopUpFile}
        title="Anexos"
        id={id && id !== '0' ? id : null}
        setExternalFiles={setFiles}
        service={relationshipService}
      />
    </>
  );
};

export default RelationshipRegistration;
